import { CEQuestion, CEQuestionResponse } from "../Shared/scriptts/interfaces";
import { setCEResponses, CEResponses, NumberOfQuestions } from "./career-explorer-main";
declare const ceQuestionsArray: CEQuestion[];
let isInitialLoad = true;

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.className += ' scroll-smooth';
    initQuiz();
});

function initQuiz() {
    initQuizQuestions().then(() => {
        updateProgress();
        bindEvents();
        isInitialLoad = false;
    })
    .catch(e => console.debug(e));
}

async function initQuizQuestions(): Promise<void> {
    return new Promise((resolve) => {
        const responseLength = CEResponses.responses.length;
        const currentQuestionIndex = CEResponses.currentQuestionIndex;
        if (responseLength === 0) {
            return resolve();
        }
        CEResponses.responses.forEach((response, i) => {
            const radio = document.querySelector<HTMLElement>(`#q${i + 1}-${response.responseValue}`);
            if (radio === null) {
                return;
            }
            displayQuestion(i + 1, false);
            setQuizRadioChecked(radio, false);
        });
        if (currentQuestionIndex === -1) {
            document.querySelector<HTMLElement>('#goToOne')?.focus();
        }
        else if (currentQuestionIndex < NumberOfQuestions) {
            const radioFocus = document.querySelector<HTMLElement>(`#q${currentQuestionIndex + 1}-${CEResponses.responses[currentQuestionIndex]?.responseValue ?? "1"}`);
            radioFocus?.focus();
        }
        if (responseLength === NumberOfQuestions) {
            displayFormSubmit(currentQuestionIndex === NumberOfQuestions);
        }
        resolve();
    });
}

function bindEvents() {
    document.querySelector<HTMLButtonElement>('#goToOne')?.addEventListener('click', () => displayQuestion(1, true));
    document.querySelectorAll<HTMLElement>('[role="radiogroup"]').forEach(radioGroup => {
        radioGroup.addEventListener('keydown', handleQuizRadioGroupKeydown);
        radioGroup.addEventListener('click', handleQuizRadioGroupClick);
    });
    document.querySelectorAll<HTMLElement>('[role="radio"]').forEach(radio => {
        radio.addEventListener('focus', () => {
            CEResponses.currentQuestionIndex = parseInt(radio.getAttribute('data-name')?.substring(1) ?? "0") - 1;
            setCEResponses(CEResponses);
        });
    });
    document.querySelector<HTMLButtonElement>('#submitQuiz')?.addEventListener('click', handleSubmitClicked);
    initIntersectionObserver();
}

function initIntersectionObserver() {
    const instructionsElement = document.querySelector<HTMLElement>('#instructions');
    const actionsElement = document.querySelector<HTMLElement>('#actions');
    const observer = new IntersectionObserver((ioEntries) => {
        ioEntries.forEach(e => {
            if (!e.isIntersecting) {
                return;
            }
            if (e.target.id === 'instructions') {
                CEResponses.currentQuestionIndex = -1;
            }
            else if (e.target.id === 'actions') {
                CEResponses.currentQuestionIndex = NumberOfQuestions;
            }
            else {
                const radioGroup = document.querySelector<HTMLElement>(`#q-${(<HTMLElement>e.target).id.substring(8)}`);
                if (radioGroup === null) {
                    return;
                }
                radioGroup.focus();
                let questionID = parseInt(radioGroup.id.substring(2) ?? "0");
                if (questionID < 1) {
                    return;
                }
                CEResponses.currentQuestionIndex = questionID - 1;
                if (CEResponses.responses.length >= questionID) {
                    const responseValue = CEResponses.responses[CEResponses.currentQuestionIndex]?.responseValue ?? "1";
                    document.querySelector<HTMLElement>(`#q${questionID}-${responseValue}`)?.focus();
                }
                else {
                    document.querySelector<HTMLElement>(`#q${questionID}-1`)?.focus();
                }
            }
            setCEResponses(CEResponses);
        })
    }, {
        root: document.querySelector<HTMLElement>('#quizContainer'),
        threshold: 1
    });
    if (instructionsElement !== null) {
        observer.observe(instructionsElement);
    }
    if (actionsElement !== null) {
        observer.observe(actionsElement);
    }
    ceQuestionsArray.forEach((question, i) => {
        const questionElement = document.querySelector<HTMLElement>(`#question${i + 1}`);
        if (questionElement !== null) {
            observer.observe(questionElement);
        }
    });
}

function handleQuizRadioGroupKeydown(evt: KeyboardEvent) {
    switch (evt.code) {
        case 'Space':
            selectResponse(<HTMLElement>evt.target);
            setCEResponses(CEResponses);
            evt.preventDefault();
            break;
        case 'ArrowUp':
        case 'ArrowLeft':
            setPreviousQuizRadioFocus(<HTMLElement>evt.target);
            evt.preventDefault();
            break;
        case 'ArrowDown':
        case 'ArrowRight':
            setNextQuizRadioFocus(<HTMLElement>evt.target);
            evt.preventDefault();
            break;
        default:
            break;
    }
}

function handleQuizRadioGroupClick(evt: Event) {
    let elem: HTMLElement | null = <HTMLElement>evt.target;
    if (elem === null || elem.role === 'radio-group') {
        return;
    }
    if (elem?.hasAttribute('data-for')) {
        elem = document.querySelector<HTMLElement>(`#${elem.getAttribute('data-for')}`);
    }
    if (elem === null || elem.role !== 'radio') {
        return;
    }
    selectResponse(elem);
    setCEResponses(CEResponses);
}

function selectResponse(elem: HTMLElement) {
    const questionNumber = parseInt(elem.getAttribute('data-name')?.substring(1) ?? "0");
    setQuizRadioChecked(elem, questionNumber > CEResponses.responses.length);
}

function setNextQuizRadioFocus(elem: HTMLElement) {
    const radioGroup = document.querySelectorAll<HTMLElement>(`[data-name="${elem.getAttribute('data-name')}"]`);
    let currentIndex = Array.from(radioGroup).findIndex(n => n.isEqualNode(elem)); 
    currentIndex = (currentIndex >= radioGroup.length - 1) ? 0 : currentIndex + 1;
    radioGroup.item(currentIndex).focus();
}

function setPreviousQuizRadioFocus(elem: HTMLElement) {
    const radioGroup = document.querySelectorAll<HTMLElement>(`[data-name="${elem.getAttribute('data-name')}"]`);
    let currentIndex = Array.from(radioGroup).findIndex(n => n.isEqualNode(elem));
    currentIndex = (currentIndex <= 0) ? radioGroup.length - 1 : currentIndex - 1;
    radioGroup.item(currentIndex).focus();
}

function goToNextQuestion(questionNumber: number) {
    if (questionNumber >= NumberOfQuestions) {
        displayFormSubmit();
    }
    else {
        CEResponses.currentQuestionIndex = isInitialLoad ? CEResponses.currentQuestionIndex : questionNumber;
        displayQuestion(questionNumber + 1, true);
    }    
}

function displayQuestion(questionNumber: number, setFocus: boolean) {
    const question = document.querySelector<HTMLElement>(`#question${questionNumber}`);
    question?.classList.remove('hidden');
    if (setFocus === true) {
        setTimeout(() => {
            question?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
    }
}

function displayFormSubmit(setFocus: boolean = true) {
    document.querySelector<HTMLElement>('#actions')?.classList.remove('hidden');
    if (setFocus === true) {
        CEResponses.currentQuestionIndex = NumberOfQuestions;
        setTimeout(() => {
            document.querySelector<HTMLButtonElement>('#submitQuiz')?.focus();
        }, 300);
        setCEResponses(CEResponses);
    }
}

function setQuizRadioChecked(elem: HTMLElement, autoNavigate = true) {
    let currentQuestion = parseInt(elem.getAttribute('data-name')?.substring(1) ?? "0");
    if (currentQuestion < 1) {
        return;
    }
    document.querySelectorAll<HTMLElement>(`[data-name="${elem.getAttribute('data-name')}"]`).forEach(radio => {
        radio.ariaChecked = "false";
        radio.tabIndex = -1;
    });
    elem.ariaChecked = "true";
    elem.tabIndex = 0;
    if (!isInitialLoad) {
        CEResponses.currentQuestionIndex = currentQuestion - 1;
        saveCEResponse(elem);
        updateProgress();
    }
    if (autoNavigate) {
        goToNextQuestion(currentQuestion);
    }
    else {
        displayQuestion(currentQuestion + 1, false);
    }
}

function saveCEResponse(elem: HTMLElement) {
    const elemValue = parseInt(elem.getAttribute('data-value') ?? "0");
    if (elemValue < 1) {
        return;
    }
    let responseValue: CEQuestionResponse = { questionID: ceQuestionsArray[CEResponses.currentQuestionIndex].questionID, responseValue: elemValue };
    if (getCurrentSavedResponse() !== null) {
        CEResponses.responses[CEResponses.currentQuestionIndex].responseValue = elemValue;
    } else {
        CEResponses?.responses.push(responseValue);
    }
}

function getCurrentSavedResponse(): CEQuestionResponse | null {
    let response = CEResponses.responses.find(rv => rv.questionID == CEResponses.currentQuestionIndex + 1);
    return (response === undefined) ? null : response;
}

function updateProgress() {
    const textElem = document.querySelector<HTMLElement>('#quizProgressText');
    const progressBar = document.querySelector<HTMLElement>('#quizProgress');
    const responsesLength = CEResponses.responses.length;

    if (responsesLength > 0) {
        document.querySelector<HTMLElement>('#progressContainer')?.classList.remove('hidden');
    }
    if (textElem !== null) {
        textElem.innerText = responsesLength.toString();
    }
    if (progressBar !== null) {
        const percentComplete = Math.round(responsesLength / NumberOfQuestions * 100);
        progressBar.style.width = `${percentComplete}%`;
    }
}

function handleSubmitClicked(evt: Event) {
    const loadingElem = document.querySelector<HTMLDialogElement>('#calculatingModal');
    const button = <HTMLButtonElement>evt.target;
    button.disabled = true;
    loadingElem?.showModal();
    const url = '/careerexplorer/saveresponses';
    const data = JSON.stringify(CEResponses);
    setCEResponses(CEResponses);
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            "Content-Type": "application/json"
        },
        body: data
    })
        .then(response => response.text())
        .then(responseData => {
            CEResponses.resultsPageIndex = 0;
            CEResponses.responseId = parseInt(responseData);
            if (CEResponses.responseId === null || isNaN(CEResponses.responseId)) {
                throw new Error('Career Explorer Controller returned non numeric response ID');
            }
            setCEResponses(CEResponses);
            setTimeout(() => {
                location.href = `/careerexplorer/results/${responseData}`;
            }, 3000);
            setTimeout(() => {
                loadingElem?.classList.add('hidden');
                button.disabled = false;
            }, 4000); 
        })
        .catch(() => {
            location.href = '/error/careerexplorer';
            setTimeout(() => {
                loadingElem?.classList.add('hidden');
                button.disabled = false;
            }, 1000);
        });
}
